var map = {
	"./Hyphen.png": 51279,
	"./Hyu.png": 82251,
	"./Lifespan.png": 15264,
	"./Renee.png": 88279,
	"./Snitch.png": 74414,
	"./Swiss Beauty.png": 11727,
	"./WeRize.png": 56284,
	"./adidas.png": 69486,
	"./amazon.png": 68575,
	"./beato.png": 59077,
	"./bella-vita.png": 35294,
	"./boat.png": 81821,
	"./boldcare.png": 51939,
	"./bombay-shaving-company.png": 49130,
	"./booking-com.png": 54811,
	"./cadbury.png": 30581,
	"./clove-oral-care.png": 96791,
	"./croma.png": 80202,
	"./dot-and-key.png": 1004,
	"./fab-india.png": 8475,
	"./firstcry.png": 4737,
	"./fitspire.png": 84804,
	"./flipkart.png": 39249,
	"./forest-essentials-india.png": 58258,
	"./foxtale.png": 89514,
	"./giva.png": 70213,
	"./go-noise.png": 48061,
	"./kama-ayurveda.png": 71828,
	"./kama.png": 88941,
	"./kindlife.png": 82301,
	"./koparo-clean.png": 93133,
	"./libas.png": 30001,
	"./mamaearth.png": 70120,
	"./max-protein.png": 78917,
	"./mcaffeine.png": 18971,
	"./medibuddy.png": 77090,
	"./minimalist.png": 4049,
	"./muscleblaze.png": 28647,
	"./neeman.png": 92484,
	"./nykaa.png": 16447,
	"./plum-goodness.png": 30923,
	"./puer.png": 86598,
	"./puma.png": 74905,
	"./shopsy.png": 62544,
	"./shyaway.png": 58341,
	"./smytten.png": 77326,
	"./sova-health.png": 22461,
	"./ssbeauty.png": 23585,
	"./the-derma-co.png": 76297,
	"./the-man-company.png": 5990,
	"./times-prime.png": 28984,
	"./truemeds.png": 42934,
	"./weryze.png": 63716,
	"./world-of-asaya.png": 50433,
	"./wow.png": 86358,
	"./xyxx-crew.png": 69601,
	"./zandu-care.png": 9580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98280;